module.exports = __webpack_public_path__ + "static/img/picture12.002aafba.png";